module.exports = __webpack_public_path__ + "f8e60ca5e8fed2b4a05704af7a234fe3.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/clear-search-icon.png
// module id = ./app/images/clear-search-icon.png
// module chunks = 3